@if (location) {
  <div id="item-{{index}}" class="item" itemscope itemtype="https://schema.org/LocalBusiness">
    <div class="item-content-wrapper" style="background-color: white">
      <a (click)="showInfo = !showInfo">
        <div class="content-media">
          <app-custom-icons [type]="iconTypes.WORK"></app-custom-icons>
        </div>
        <div class="content-item">
          <span class="title" itemprop="name">{{ location.displayName || location.name }}</span>
          <span class="description">{{ location.address.town }}</span>
        </div>
        <div class="content-action">
          @if (showInfo) {
            <app-custom-icons [type]="iconTypes.MINUS"></app-custom-icons>
          } @else {
            <app-custom-icons [type]="iconTypes.ADD"></app-custom-icons>
          }
        </div>
      </a>
      <div class="info-wrapper" [class.collapsed]="!showInfo">
        <div class="separator"></div>
        <div class="content">
          <div itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
            <div>{{ location.description }}</div>
            <div itemprop="streetAddress">{{ location.address.line1 }}</div>
            <div>
              <span itemprop="postalCode">{{ location.address.postalCode }}</span>&nbsp;
              <span itemprop="addressLocality">{{ location.address.town }}</span>,&nbsp;
              <span itemprop="addressRegion">{{ location.address.region.name }}</span>
            </div>
          </div>
          <div>
            <span>{{ 'stores.ourStores.phone' | cxTranslate }}</span>&nbsp;
            <span itemprop="telephone">{{location.address.phone}}</span>
          </div>
          <div itemprop="openingHours" [innerHTML]="location.openingHours?.name"></div>
          <div class="contacts">
            <a href="http://maps.google.com/maps?q={{location.geoPoint.latitude}},{{location.geoPoint.longitude}}&ll={{location.geoPoint.latitude}},{{location.geoPoint.longitude}}&z=17" target="_blank" class="action-link">
              <app-custom-icons [type]="iconTypes.LOCATION"></app-custom-icons>&nbsp;
              <span>
                {{ 'stores.ourStores.howToGet' | cxTranslate }}
              </span>
            </a>
            &nbsp;
            <a href="tel:{{location.address.phone}}" class="action-link phone">
              <app-custom-icons [type]="iconTypes.CALL"></app-custom-icons>&nbsp;
              <span>
                {{ 'stores.ourStores.call' | cxTranslate }}
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
}
